import { createWebHistory, createRouter } from 'vue-router'
import { toast, rolesHelper, functions } from '../helpers'
import Home from '@/views/Home.vue'
import store from '@/store';
import {proxyService} from "@/services";

const routedefs = [
    {
        path: '/login',
        name: 'Login',
        beforeEnter: (to, from, next) => {
            next({ path: '/' });
        }
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/versements',
        name: 'Versements',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "versements" */ '@/views/Versements.vue')
    },
    {
        path: '/generatefsd',
        name: 'Generatefsd',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import('@/views/GenerateFSD.vue') /* webpackChunkName: "generatefsd" */
    },
    {
        path: '/checkfsd',
        name: 'Checkfsd',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webpackChunkName: "checkfsd" */ '@/views/CheckFSD.vue')
    },
    {
        path: '/checkfsd/:mode',
        name: 'Loadfsd',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webpackChunkName: "checkfsd" */ '@/views/CheckFSD.vue')
    },
    {
        path: '/savefsd',
        name: 'Savefsd',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webpackChunkName: "savefsd" */ '@/views/SaveFSD.vue')
    },
    {
        path: '/listfsd',
        name: 'Listfsd',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "listfsd" */ '@/views/ListFSD.vue')
    },
    {
        path: '/submitfsd',
        name: 'Submitfsd',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM', 'Prestataire collecte DPSM'] },
        component: () => import(/* webPackChunkName: "submitfsd" */ '@/views/SubmitFSD.vue')
    },
    {
        path: '/asis',
        name: 'Asis',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "asis" */ '@/views/ASIS.vue')
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "dashboard" */ '@/views/Dashboard.vue')
    },
    {
        path: '/profils-saisie',
        name: 'ProfilsSaisie',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "profils-saisie" */ '@/views/ProfilsSaisie.vue')
    },
    {
        path: '/suggestions',
        name: 'Suggestions',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "suggestions" */ '@/views/Suggestions.vue')
    },
    {
        path: '/materiel',
        name: 'Materiel',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "materiel" */ '@/views/Materiel.vue')
    },
    {
        path: '/surveillance',
        name: 'surveillance',
        meta: { layout: 'extended' },
        component: () => import(/* webPackChunkName: "surveillance" */ '@/views/Surveillance.vue')
    },
    {
        path: '/surveillanceTopo',
        name: 'surveillanceTopo',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM', 'Lecteur données surveillance'] },
        component: () => import(/* webPackChunkName: "surveillance" */ '@/views/SurveillanceTopo.vue')
    },
    {
        path: '/acquisition',
        name: 'AcquisitionIndex',
        meta: { roles: ['Administrateur DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "configacquisition" */ '@/views/IndexACQ.vue')
    },
    {
        path: '/acquisition/ajouter',
        name: 'acquisition-ajouter',
        meta: { roles: ['Administrateur DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "configacquisition" */ '@/views/EditACQ.vue')
    },
    {
        path: '/acquisition/modifier/:id',
        name: 'AcquisitionModifier',
        meta: { roles: ['Administrateur DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "configacquisition" */ '@/views/EditACQ.vue')
    },
    {
        path: '/rapports',
        name: 'Rapports',
        meta: { roles: ['Utilisateur collecte DPSM', 'Administrateur collecte DPSM'] },
        component: () => import(/* webPackChunkName: "rapports" */ '@/views/Rapports.vue')
    },
    {
        path: '/404',
        name: 'notfound',
        meta: { layout: 'no-sidebar' },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "notfound" */ '@/views/404.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routedefs
})

router.beforeResolve(async (to, from, next) => {
    const publicPages = ['/404']
    const isLoggedIn = store.getters['authentication/loggedIn'];
    if (to.path === '/login') {
        return next({ path: '/' });
    }
    if (to.meta.roles && !isLoggedIn) {
        return next(); // on laisse passer, l'interceptor gérera le 401 / login Keycloak
    }
    if (to.meta.roles) {
        var hasRole = rolesHelper.hasAnyRole(to.meta.roles)
        if (!hasRole) {
            toast.warning('Vous n\'avez pas le droit d\'accéder à cette section')
            return next({ path: from.path })
        }
    }

    /*if (authRequired && !loggedIn) { 
        if (to.path != "/") {
            return next({ path: '/login', query: { redirect: to.fullPath } })
        }
        else {
            return next({ path: '/login'})
        }
    }*/

    const redirectedFrom = from.query.redirect

    if (to.name == 'Home' && !functions.isNullOrEmpty(redirectedFrom)) {
        const [path, query] = redirectedFrom.split("?")
        if (!functions.isNullOrEmpty(query)) {
            next(`${path}?${query}`)
        }
        else {
            next(`${path}`)
        }
    }
    else {
        next()
    }

})

export default router
